// import { useForm } from "@mantine/form";
import { useMutation } from "@tanstack/react-query";
import { updateMatchStyle } from "../../../api/matchStyle";
import { useNavigate } from "react-router-dom";

const useCreate = () => {
    const navigate = useNavigate()
    const createMutation = useMutation({
        mutationFn: updateMatchStyle,
        onSuccess: async (response) => {
            try {
                navigate("/matchStyle", {
                    replace: true
                })
            } catch (error) {
                console.error(error);
            }
        }
    })

    return { createMutation }

}

export default useCreate;
